<template>
  <navigator-shell :showNav="false" :requestRecordingPermission="true" :themeCss="'theme-dark bg-theme-darkest'">
    
    <div class="theme-dark">  
      <div v-show="state==CardViewerState.loading" class="viewer">
        <transition name="card">
         <div class="card-container loader"   > 
              <fullscreen-loader />
         </div>
         </transition>
      </div>
 
      <div v-show="state==CardViewerState.started" class="container-fluid p-0 vh-100 d-flex flex-column">
      <div class="row no-gutters flex-grow-1 justify-content-center">
 <!-- :class="!showCaptionsPanel ? 'justify-content-center' : 'cruftymaxbro' " -->
        <div 
            class="col-12 col-lg-7 d-flex justify-content-start"
            :class="cardData ? 'bg-theme-darkest' : 'bg-dark'"
          >
          
          
          <div class="player-container embed-responsive embed-responsive-16by9 w-100" >
            <mux-player-emurse 
             class="embed-responsive-item"
              :videoId="lessonController.lesson.meta.video.id"
              :videoType="lessonController.lesson.meta.video.type"
              @playerLoaded="onMuxPlayerCreated" 
              @ended="onEnded"
              @aspectratio="onVideoAspectRatio"
              :autoplay="true" 
            >
 
             <template v-slot:control-bar>
               <button class="btn-emurse-player pl-1 pr-2" @click="showCaptionsPanel=!showCaptionsPanel"
                 v-if="captions?.length>0"
               >
                <icon :name="'layout-sidebar-inset'" />
              </button>
             </template>             
            </mux-player-emurse>
             
             <div class="player-overlay">

              <video-overlay :items="overlayItems" v-if="!completeLessonResponse"
                :segmentMap="segmentMap"
                :aspectRatio="videoAspectRatio"
                 @segmentClick="onSegmentClick"
                 @navButtonClick="onNavButtonClick"
              />

              <transition name="fade">
            <div  v-if="completeLessonResponse" class="overlay-view" >
              <div  class="bg-theme-darkest h-100 w-100 d-flex flex-column" >
                <video-lesson-end-screen 
                  class="h-100"
                  @replay="replayVideo"
                  :completeLessonResponse="completeLessonResponse"
                  :isLoggedIn="isLoggedIn" />
    
              </div>
            </div>
          </transition>

          <div class="overlay-view" v-if="segmentLoading && !cardData">
            <div class="bg-theme-darkest h-100 w-100 d-flex align-items-center justify-content-center">
              <div style="width:6rem;height:6rem;"><fullscreen-loader /></div>
            </div>
          </div>

          <transition name="fade">
          <div class="overlay-view"  v-if="cardData" > 
            <div class="bg-theme-darkest h-100 w-100 d-flex flex-column" :class="{'fixed-overlay': isPortrait}" >
                <card-item v-if="!cardChanging" ref="cardItem"  class="card-item flex-grow-1" :cardData="cardData" />
                <div class="p-3 align-items-center justify-content-center d-flex">
                  <button class="btn btn-danger mr-2" v-if="!canContinueLesson" @click="closeCard">Close <icon :name="'x'" /></button>
                  <button class="btn" :class="{'btn-success':canContinueLesson, 'btn-secondary':!canContinueLesson}"
                   @click="continue2()" :disabled="!canContinueLesson" >Continue <icon :name="'chevron-right'" /> </button>
                </div>
            </div>    
            <button class="btn badge btn-danger" v-if="isPortrait" style="position:fixed;top:1rem;right:1rem;z-index:3;" @click="forceContinue"><icon :name="'x'" /></button>            
          </div>
          </transition>      
         
            </div> 
          </div>
        </div>

        <div class="col-12 col-lg-5 d-flex flex-column bg-theme  captions-container"
        :ref="el => {captionsContainer = el as HTMLElement } "
        v-if="showCaptionsPanel && captions?.length>0">
            <div class="d-flex p-2 flex-shrink-0" id="captionsUi" >
              <button v-if="!showTermsPanel && disableAutoScroll && !player.paused()" class="btn badge btn-secondary" @click="sync"  >Sync</button>
              <div class="flex-grow-1"></div>
              <button v-if="transcriptDetailRowConfig && !showTermsPanel" class="btn badge mr-1"
                :class="showTranscriptDetails ? 'btn-primary' : 'btn-secondary'"
                :title="showTranscriptDetails ? 'Hide term details' : 'Show term details'"
                @click="showTranscriptDetails=!showTranscriptDetails">
                Detail <icon :name="showTranscriptDetails ? 'eye' : 'eye-slash'" />
              </button>
              <button v-if="transcriptTerms.length>0" class="btn badge btn-secondary mr-1" @click="toggleTermsPanel">{{ showTermsPanel ? 'Transcript' : 'Terms' }}</button>
              <button class="btn badge btn-danger" @click="showCaptionsPanel=false"><icon :name="'x'" /></button>
            </div>

          <div ref="captionsList" v-show="!showTermsPanel" class="p-4 flex-grow-1 fill-row captions-list" @scroll="onCaptionsScroll">
            <!-- <div class="captions-spacer" aria-hidden="true"></div>             -->
            <table class="table table-sm">
            <template v-for="caption in captions" >
              <tr   
              v-if="hasText(caption) || caption.viewModel.hasTranscriptAnnotations || caption?.terms?.length>0 "
                    :class="{'caption-new': !caption?.viewModel?.entered,
                        'caption-visited': caption?.viewModel?.entered,
                        'caption-active': caption?.viewModel?.active,
                        }">
                <td @click="seekTo(caption.startMs)" class="time-stamp">
                  <span v-show="getEntryItemCount(caption)>0" class="mr-1">•</span>
                  <span>{{dayjs.duration(caption.startMs).format(durationFormat)}}</span>
                 </td>
                <td>
               <div class="d-flex justify-content-start align-items-center"
                :ref="el => { if (caption.viewModel?.active) activeCaptionEl = el as HTMLElement } " >

                  <span class="text-left" @click="caption.selected=!caption.selected"> {{ caption.text ?? caption.display ?? caption.customText }}  </span>
    
                  <template v-if="isCaptionRevealed(caption)">
                    <div class="btn p-0 ml-1" v-if="caption.term"  @click="onFavoriteClick(caption.term)" fill="currentColor" >
                              <svg  class="bi bi-heart text-danger">
                              <use v-if="caption.term?.isFavorite" :xlink:href="getIcon('heart-fill')"></use>
                              <use v-else :xlink:href="getIcon('heart')"></use>
                              </svg>
                    </div>
                    <div v-if="caption?.viewModel?.hasTranscriptSegments" >
                       <template v-for="segment in caption.segments">
                           <button v-if="/both|transcript/.test(segment.location)" class="btn badge btn-danger ml-3" @click="onSegmentClick({...segment, entry: caption})" >{{ segment?.text ?? "Exercise" }}</button>
                       </template>
                    </div>

                    <div v-if="caption?.viewModel?.hasTranscriptNavButtons" >
                       <template v-for="navButton in caption.navButtons">
                           <button v-if="/both|transcript/.test(navButton.location)" :class="[btnClass(navButton.className), 'ml-3']" @click="onNavButtonClick(navButton)" >{{ navButton.text }}</button>
                       </template>
                    </div>
                  </template>
               </div>

               <div class="mt-2 text-left" v-if="caption.viewModel.hasTranscriptAnnotations || caption?.terms?.length>0 || showTranscriptDetailRow(caption)">
                     <div v-if="caption.viewModel.hasTranscriptAnnotations">
                        <template v-for="a in caption?.annotations">
                          <div class="annotation" v-if="/both|transcript/.test(a.location)" ><i>{{a.text}}</i></div>
                        </template>                          
                    </div>
           
                    <term-list-detail-row v-if="showTranscriptDetailRow(caption)" :key="caption.term?.id" class="transcript-detail-row"
                      :term="caption.term" :config="transcriptDetailRowConfig" />

                    <div v-if="caption?.terms?.length>0" class="d-flex related-terms">
                      <span><strong>Related Terms:</strong></span>
                      <div v-for="term in caption.terms" class="d-flex align-items-center mr-1" 
                       @click="onFavoriteClick(term)" >
                       <span>{{ term.text ?? term.tid }}</span>

                       <svg  class="bi bi-heart text-danger ml-1" fill="currentColor" >
                              <use v-if="term?.isFavorite" :xlink:href="getIcon('heart-fill')"></use>
                              <use v-else :xlink:href="getIcon('heart')"></use>
                       </svg>
                      </div>

                    </div>     
               </div>
                </td>
              </tr>
               </template>
            </table>
            <div class="captions-spacer" aria-hidden="true"></div>  
          </div>

          <div ref="termsList" v-if="showTermsPanel" class="p-2 flex-grow-1 fill-row terms-list">
            <termlist-viewer :initialItems="transcriptTerms" :columns="{favorites:true}"
              :detailRowConfig="detailRowConfig" :language="lessonController.lesson.language" />
          </div>
        </div>

      </div>
      </div>

         <!-- <div class="card-container" v-for="(cardData,index) in cards" :key="index">
            <transition :name="cardTransition">
             
            </transition>         
         </div>
        <transition name="lp">   
           <terms-panel @addFavorite="addFavorite" @removeFavorite="removeFavorite" :terms="encounters.allProgress" v-if="showTerms" :class="{'no-terms':encounters.animatedProgress.length==0}" @close="showTerms=false" />    
        </transition>      -->
    <transition name="fade" > 

        <div v-if="state==CardViewerState.complete" >
           the lesson has ended!
        </div>
     </transition>

     <transition name="fade" > 

      <div  v-if="state==CardViewerState.error" >
        <lesson-error-screen :lessonController="lessonController" />
      </div>

     </transition>

   
         <audio ref="correct" src="https://emurseassets.blob.core.windows.net/cardviewer/correct.mp3" /> 
         <audio ref="incorrect" src="https://emurseassets.blob.core.windows.net/cardviewer/incorrect.mp3"/>
     
  </div>
  </navigator-shell>
</template>

<script lang="ts">
import { Options,Provide,Inject, Prop, Vue } from 'vue-property-decorator';



import { CardData, ReplayItem, ReplaySegment } from './CardData';
import CardItem from './CardItem.vue';
import { EntryRepository } from '@/data/repository/EntryRepository';
import {LessonController, LessonContext} from '@/controllers/LessonController';
import { Term } from '@/data/repository/DictionaryRepository';
import FullscreenLoader from '@/components/core/FullscreenLoader.vue'
import { CompleteLessonResponse, CourseRepository, isTranscriptTermsSegment} from '@/data/repository/CourseRepository'; 
import TermlistViewer from '@/components/core/TermlistViewer.vue';
import TermListDetailRow from '@/components/core/TermListDetailRow.vue';
import LessonErrorScreen from './LessonErrorScreen.vue';

import { ShellController, safariViewportFix } from '../shell/Shell';
import { PreferencesController } from '@/controllers/PreferencesController';
import { DashboardRepository,  } from '@/data/repository/DashboardRepository';
import { CardFactory } from './types/CardFactory';
import { type ILanguageFeatures } from '@/languages/LanguageFeatures';
import TermsPanel from './TermsPanel.vue'
import {CardViewerState, playElement, ProgressItemViewModel} from './CardViewer';
import NavigatorShell from '@/components/shell/NavigatorShell.vue';
import { EmurseContext } from "@/EmurseContext";
import Icon from '@/components/core/Icon.vue'; 
import YouTubePlayer from '../core/YouTubePlayer.vue';
import { type YTPlayerHandle, TimestampController, type IPlayer, type PlaybackWindow, getEntryItemCount } from './TimestampController';
import { buildPlaybackWindows, buildAutoPlayTriggers, hasDefaultTrigger, resolveOnContinueMs } from './PlaybackOptions';
import { type ISegmentNavigator } from '@/controllers/cards/SegmentNavigatorBase';
import {icon as getIcon, } from '@/components/shell/Shell'; 
import { YTPlayerWrapper } from '../core/YouTubePlayerWrapper';
import MuxPlayerEmurse from '../core/MuxPlayerEmurse.vue';
import { ContinueResult } from '@/controllers/cards/CardBuilder';  
import VideoLessonEndScreen from './VideoLessonEndScreen.vue';
import VideoOverlay from '@/components/cards/VideoOverlay.vue';
import { resizeFillRow } from '../core/Dom';
import { btnClass } from '@/components/core/ButtonStyle';

import dayjs, { Dayjs, locale } from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat'
import duration from 'dayjs/plugin/duration'; 
import { ProfileInfo } from '@/data/repository/UserInfo';

dayjs.extend(localizedFormat);
dayjs.extend(duration);

@Options({  
  components:{CardItem, 
                      FullscreenLoader,Icon,
                    VideoLessonEndScreen,LessonErrorScreen, TermsPanel, NavigatorShell, YouTubePlayer, MuxPlayerEmurse,
                  VideoOverlay, TermlistViewer, TermListDetailRow }})
export default class VideoViewer extends Vue { 
   public isNavigating = false;
   public dayjs = dayjs;

   @Inject() public apps!: any[];
   @Inject() public profile!: ProfileInfo;
   @Inject() public lessonController!: LessonController;
   @Inject() public entryRepository!: EntryRepository; 
   @Inject() public courseRepository!: CourseRepository;
   @Inject() public dashboardRepository!: DashboardRepository;
   @Inject() public shellController!: ShellController;
   @Inject() public preferencesController!: PreferencesController;
   @Inject() public emurseContext!: EmurseContext;
  
   @Provide("cardFactory") public cardFactory: CardFactory = new CardFactory();

   //@Inject() public languageFeatureTypes!: LanguageFeatureTypes;
   @Provide("languageFeatures") public languageFeatures!: ILanguageFeatures;

   public CardViewerState = CardViewerState; 
   protected activeCaptionEl: HTMLElement | null = null;
   protected captionsContainer: HTMLElement | null = null;

   protected segmentMap: Map<string,any> = new Map();
    protected viewedSegmentMap = new Map<string,any>();

   //proxy for LessonProgress object in LessonController lesson progress
   public lessonContext!: LessonContext;
   public getIcon = getIcon;
   public getEntryItemCount = getEntryItemCount;
   public btnClass = btnClass;

   public showCaptionsPanel = true;
 
   public encounters: ProgressItemViewModel = new ProgressItemViewModel();
   public state=CardViewerState.loading;
   public timestampController: TimestampController | null = null;
   public completeLessonResponse: CompleteLessonResponse | null = null;
   public showTerms = false;
   // Terms panel: the transcript-terms segment's terms, and the course's term list detail row config.
   public showTermsPanel = false;
   public transcriptTerms: any[] = [];
   public detailRowConfig: any = null;
   // lesson.meta.transcriptDetailRow: shown under a selected transcript line, bound to the line's term.
   public transcriptDetailRowConfig: any = null;
   // The transcript bar's details toggle. Starts at the creator's defaultVisible (unset → shown).
   public showTranscriptDetails = true;
   public cardData: any | null = null;
   public cardChanging = false;
   public segmentLoading = false;
   protected segmentRequestId = 0;
   public replayItems: ReplayItem[] =[]
   public replaySegments: ReplaySegment[] = [];
   public captions: any[] = [];
   public annotations: any[] = []; 
   public overlayItems: any[] = [];
   // Set while the open card came from an autoplay segment; its onContinue runs when Continue finishes it.
   protected autoPlayContext: { segment: any, entry: any } | null = null;
   public videoAspectRatio = 16 / 9;
   
   //
   public newTerms = 0;

   //explainer settings
   public ranExplainerTermcount = false;

   public get isLoggedIn(): boolean
   {
     return this.profile ? true : false;
   }

   public segmentNavigator: ISegmentNavigator | null = null;
   public player: any | null = null;
   public maxStartMs = -1;
   public cardTransition = "card";
   public isAutoScroll = false;

   public disableAutoScroll = false;
   public didAutoScroll = false;


     isPortrait: boolean = false
  private mediaQuery: MediaQueryList | null = null
 
  private onOrientationChange(e: MediaQueryListEvent): void {
    this.isPortrait = e.matches
  }
   public sync()
   {
     this.disableAutoScroll=false;
     this.scrollActiveCaptionIntoView();
   }

   public seekTo(time: number)
   {
        (this.player as IPlayer).seekTo(time);
   }

   public replayVideo()
   {
    this.completeLessonResponse = null;
    this.cardData = null;
    (this.player as IPlayer).seekTo(0);
    (this.player as IPlayer).play();
   }
 
   public onSegmentClick(overlayItem: any)
   {
    let segmentId = overlayItem?.items[0]?.id;

    if (segmentId) {
      // Opened by the learner: finishing it just resumes playback.
      this.autoPlayContext = null;
      this.showSegment({id: segmentId, entry: overlayItem.entry, segmentItem: overlayItem});
    }
   }

   public onNavButtonClick(navButton: any)
   {
    this.timestampController?.navigate(navButton.navType, navButton.value);
   }

   public onFavoriteClick(term: any)
   {
    term.isFavorite=!term.isFavorite;

    if (term.isFavorite)
    {
      this.addFavorite(term);
      let text = term?.text ?? '';
      if (text.length>15) text=text.substring(0,15) + '...'
      this.shellController.alert(`Added favorite "${text}" `);
    }
    else {
      this.removeFavorite(term)
    }
   }

   protected onYtPlayerCreated(playerHandle: YTPlayerHandle)
   {
      let player = new YTPlayerWrapper(playerHandle);
      this.player=player;
      this.initController();
   }

   protected onEnded()
   {
    // Some players fire "ended" a little early — give any cuepoint sitting
    // at the tail of the video a chance to fire before treating the lesson
    // as actually complete. If one navigates elsewhere, the video isn't
    // really done; don't show the end screen.
    if (this.timestampController?.flushPendingCuepoints()) {
      return;
    }

    this.beginCompleteLesson();
   }

   protected onMuxPlayerCreated(player: IPlayer)
   {
    this.player = player;
    this.initController();
   }

   protected onVideoAspectRatio(ratio: number)
   {
    this.videoAspectRatio = ratio;
   }

   protected getSegmentById(id: string)
   {
    return this.segmentMap.get(id);
   }

   protected initController()
   {
    const lesson = this.lessonController.lesson;
    const video = this.lessonController.lesson.meta.video;

    //segments by ID
    //TODO: move to controller, probably
      if (lesson?.segments)
      { 
        lesson.segments.forEach( (s: any)=>{
          this.segmentMap.set(s.id,s);
          }
        )
      }
 
 
     let t = video.transcript;
     const l = Object.keys(t);
     let locale = l[0]; 

    const id=t[locale].id; //first locale
    
     this.courseRepository?.getLessonTranscript(lesson.uid, id).then(response=>{

      const transcript = response.responseData.transcript;
      if (!transcript.entries) {
        transcript.entries=[];
      }
 
      this.initItems(transcript.entries);

    });

    this.initTermsPanel();
    this.initTranscriptDetailRow();

  
   }

   protected initTranscriptDetailRow()
   {
    const config = this.lessonController.lesson?.meta?.transcriptDetailRow;
    this.transcriptDetailRowConfig = config?.sections?.length > 0 ? config : null;
    this.showTranscriptDetails = config?.defaultVisible !== false;

    // User Preference filters read the enrollment settings. Load them once here; each section would otherwise ask on mount.
    const usesUserSetting = (config?.sections ?? []).some((s: any) =>
      (s?.visibility?.filtering?.filters ?? []).some((f: any) => f?.type == 'userSetting'));

    if (usesUserSetting) {
      this.emurseContext.getCourseEnrollmentSettings().catch(() => null);
    }
   }

   // A line's heart, segment and nav buttons, and detail row show once playback has reached it, or it's active, entered or selected.
   public isCaptionRevealed(caption: any): boolean
   {
    return this.maxStartMs >= caption.startMs ||
      !!caption?.viewModel?.active ||
      !!caption?.viewModel?.entered ||
      !!caption?.viewModel?.selected;
   }

   // Same visibility as the line's buttons, only when the line has a term, and only while the details toggle is on.
   public showTranscriptDetailRow(caption: any): boolean
   {
    return !!(this.transcriptDetailRowConfig && this.showTranscriptDetails && caption?.term && this.isCaptionRevealed(caption));
   }

   protected entryTerms: Map<string,any> = new Map();
   protected itemId = 0;

   protected getEntryVm()
   {
    return {id: this.itemId++, 
      entered: false, 
      active: false,
      selected: false,
      favoriteTerm: false, 
      hasTranscriptSegments: false,
      hasTranscriptAnnotations: false,
      hasTranscriptNavButtons: false };
   }

   public beginCompleteLesson()
   {
      this.courseRepository.completeLesson(this.lessonController.lessonUid, this.lessonController.courseUid).then((response)=>{
        this.completeLessonResponse = response;
      });
   }

   protected hasText(caption: any)
   {
     return (caption.text ?? caption.display ?? caption.customText ?? '').length>0 
   }

   protected onCaptionsScroll(event: Event)
   {

     if (this.isAutoScroll) {
      this.isAutoScroll = false;
      return;
     }



     if ( !(this.player as IPlayer).paused() )
     {
        this.disableAutoScroll = true;
     }
     else {
      this.disableAutoScroll = false;
     }

   }

  protected scrollActiveCaptionIntoView() {

    if (this.disableAutoScroll) { 
      return;
    }



  const container = this.$refs.captionsList as HTMLElement;
  const el = this.activeCaptionEl;
  if (!container || !el) return;

  const containerRect = container.getBoundingClientRect();
  const elRect = el.getBoundingClientRect();

  const isVisible = elRect.top >= containerRect.top && elRect.bottom <= containerRect.bottom;

  if (!isVisible) {
    const isBelowBottom = elRect.bottom > containerRect.bottom;
    const isAboveTop = elRect.top < containerRect.top;
    this.isAutoScroll=true;
    el.scrollIntoView({ block:  isBelowBottom ?  "center" : "start", behavior:"smooth" });
  }

    this.didAutoScroll=true;
}

   // Overlay items come and go with their own display windows (PlaybackOptions.ts), not their line.
   public showOverlayWindow(window: PlaybackWindow)
   {
      const item = window.item;
      this.overlayItems.push({...{type: window.type, entry: window.entry, position: item.position ?? 0}, ...item, windowId: window.id});
   }

   public hideOverlayWindow(window: PlaybackWindow)
   {
      const index = this.overlayItems.findIndex(oi => oi.windowId === window.id);
      if (index >= 0) this.overlayItems.splice(index, 1);
   }

   // Line entered: name untitled segments, and open a default-timed autoplay segment (last one wins).
   // Autoplay segments with custom timing open from the controller's "segment:autoplay" instead.
   public applyLineItems(entry: any)
   {
      let autoPlaySegment: any = null;

      entry?.segments?.forEach( (item: any) =>{
        if (!item.text) {
          item.text = this.getSegmentById(item.items[0].id)?.name ?? 'Exercise'
        }

        if (item.autoPlay && hasDefaultTrigger(item)) {
          autoPlaySegment = item;
        }
      });

      if (autoPlaySegment) {
        this.playAutoPlaySegment(autoPlaySegment, entry);
      }
   }

   public playAutoPlaySegment(segment: any, entry: any)
   {
      const segmentInfo = segment?.items?.[0];
      const segmentId = segmentInfo?.id;

      if (!segmentId) return;

      if (!segment.text) {
        segment.text = this.getSegmentById(segmentId)?.name ?? 'Exercise';
      }

      this.autoPlayContext = { segment, entry };
      this.showSegment({id: segmentId, entry, segmentInfo, segmentItem: segment});
   }

   public initItems(entries: any[])
   {   
      this.captions = entries;
      //add client ids
      entries.forEach( (ti: any)=>{
        let vm = this.getEntryVm();
        ti.viewModel=vm;

        const tid = ti?.term?.tid;

        if (tid)
        {
         this.emurseContext.getTermDetail(tid,
          {includeAudio: true, includeImages: false} ).then(td=>{
           this.emurseContext.setFavoriteStatus(td as any);
           this.entryTerms.set(ti.term.id, td); 
           ti.term=td;
         });
        }

       // let map: any = {}
        
        if (ti?.terms?.length>0) {
          for (let i=0;i<ti.terms.length;i++) {

            let term =  ti.terms[i];
            term.index=i;

            if (term.tid)
            {
              this.emurseContext.getTermDetail(term.tid,
                  {includeAudio: true, includeImages: false} ).then(td=>{

                    this.entryTerms.set(td.id, td);                     
                    term = {...term, ...td, ...{isFavorite: false}};
                    this.emurseContext.setFavoriteStatus(term);
                    ti.terms[term.index] = term;
                })
            }

          }
        }

        if (ti.segments?.length>0) {
          vm.hasTranscriptSegments = ti.segments.find( (s: any) => /both|transcript/.test(s.location) ) ? true : false;
        }

         if (ti.annotations?.length>0) {
          vm.hasTranscriptAnnotations = ti.annotations.find( (s: any) => /both|transcript/.test(s.location) ) ? true : false;
        }

         if (ti.navButtons?.length>0) {
          vm.hasTranscriptNavButtons = ti.navButtons.find( (s: any) => /both|transcript/.test(s.location) ) ? true : false;
        }

      })

      this.captions = entries;
      this.overlayItems = [];
      this.timestampController = new TimestampController({
        player: this.player,
        items: entries,
        windows: buildPlaybackWindows(entries),
        autoPlayTriggers: buildAutoPlayTriggers(entries),
      });
      this.timestampController.emitter.on("item:enter",(item: any) =>{
                if (item.startMs>this.maxStartMs)
        {
          this.maxStartMs=item.startMs;
        }
        
        if (!item.viewModel)
        {
          item.viewModel = this.getEntryVm();
        }

        let vm = item.viewModel;

        if ( !vm?.active) {
            vm.active=true;         
            this.applyLineItems(item);
        }

        this.$nextTick(()=>{
          this.scrollActiveCaptionIntoView();
        })

      });

      this.timestampController.emitter.on("item:exit",(item: any) =>{
        item.viewModel.active=false;
        item.viewModel.entered=true;
       });

      this.timestampController.emitter.on("window:enter",(window: PlaybackWindow) =>{
        this.showOverlayWindow(window);
      });

      this.timestampController.emitter.on("window:exit",(window: PlaybackWindow) =>{
        this.hideOverlayWindow(window);
      });

      this.timestampController.emitter.on("segment:autoplay",({ item, entry }: { item: any, entry: any }) =>{
        this.playAutoPlaySegment(item, entry);
      });


      this.timestampController.start();
   }

   public menuButtonClicked()
   {
    console.log("menu button clicked.");
   }
 
   protected initEvents(cardData: any)
   {
        if (this.cardData?.data?.events)
        {
          this.cardData.data.events.on("continue",()=>{
            this.continue2();
          });

        }

   }

   // segmentProperties: {id, entry, segmentItem} - segmentItem is the line's segment (entry.segments[n]), which holds termSource.
   public async showSegment(segmentProperties: any, $event: MouseEvent | null = null)
   {
    if ($event) {
      $event.stopPropagation();
    }

    const segmentId = segmentProperties.id;
    const entry = segmentProperties.entry;
    const termSource = segmentProperties.segmentItem?.termSource ?? {segment: true, line: false, related: false};
    const onlySegment = termSource.segment && !termSource.line && !termSource.related;
    const cacheKey = onlySegment ? segmentId : `${segmentId}-${entry?.viewModel?.id}`;

    const existing = this.viewedSegmentMap.get(cacheKey);

    if (existing)
    {
      this.cardData = existing.cardData;      
      this.segmentNavigator = existing.segmentNavigator;
      this.player.pause();
      return;
    }

    const baseNavigator = this.lessonController.setSegmentNavigatorBySegmentId(segmentId);

    if (!baseNavigator) return;

    this.player.pause();

    const request = ++this.segmentRequestId;
    this.segmentLoading = true;

    try {
      let segmentNavigator: ISegmentNavigator | null = null;

      if (!onlySegment) {
        const terms = await this.getTermSourceTerms(termSource, entry);
        segmentNavigator = this.lessonController.createSegmentNavigatorWithTerms(segmentId, terms, termSource.segment);
      }

      // Segment only, or the term source came up empty: use the segment as it is.
      segmentNavigator ??= baseNavigator;

      await this.lessonController.createCardBuilder(segmentNavigator.getSegment());

      // A different segment was opened while this one loaded.
      if (request != this.segmentRequestId) return;

      const cardData = this.lessonController.buildCardWithNavigator(segmentNavigator);

      this.cardData = cardData;
      this.segmentNavigator = segmentNavigator;
      this.viewedSegmentMap.set(cacheKey, {cardData, segmentNavigator});
      this.initEvents(cardData);
    }
    finally {
      if (request == this.segmentRequestId) {
        this.segmentLoading = false;
      }
    }
   }

   // Line and related terms from the entry. initItems loads their details without waiting, so wait for them here.
   protected async getTermSourceTerms(termSource: any, entry: any): Promise<any[]>
   {
    const terms: any[] = [];

    if (termSource.line && entry?.term) {
      terms.push(entry.term);
    }

    if (termSource.related && entry?.terms?.length > 0) {
      terms.push(...entry.terms);
    }

    const details = await Promise.all(terms.map((t: any) => t?.tid ?
      this.emurseContext.getTermDetail(t.tid, {includeAudio: true, includeImages: false}).catch(() => null) :
      Promise.resolve(t)));

    return details.filter((t: any) => t);
   }

   get durationFormat(): string {
    if (this.captions)
    {
      const ONE_HOUR_MS = 3600000;
      const TEN_MINUTES_MS = 600000;

      let duration = this.captions[this.captions.length-1].endMs;

      if (duration >= ONE_HOUR_MS) {
        return 'HH:mm:ss';
      } else if (duration >= TEN_MINUTES_MS) {
        return 'mm:ss';
      } else {
        return 'm:ss';
      }
    }

    return 'HH:mm:ss';
  }

   public forceContinue()
   {
     this.autoPlayContext = null;
     this.cardData=null;
     this.segmentNavigator =null;
     this.resumeVideo();
   }

   public get canContinueLesson()
   {
    const result = this.cardData?.data?.canContinue;
    console.log(`get can continue: ${result}`)
    return result;
   }

   public closeCard()
  {
    this.autoPlayContext = null;
    this.shellController.stopAllPlayback();
    this.cardData = null;
    this.resumeVideo();    
  }

    public continue2()
   {

     const controller=this.cardData.data; 
     if (controller.continue)
     {
          controller.continue().then( (continueResult: ContinueResult)=>{

          this.shellController.stopAllPlayback();
          
          if (continueResult.action=="scored")
          {
            const audioElement: HTMLAudioElement = (controller.score==1 ? this.$refs.correct : this.$refs.incorrect)  as HTMLAudioElement
            this.playElement(audioElement);        
            //this.scoredTotal++;
          }
       
          if (continueResult.shouldMoveNext) {
                this.continueLesson();
          }
          else
          {
              this.isNavigating = false;
          }
        });

     }
     else {
     
     }
   }

   // An autoplay segment was finished with Continue: follow its onContinue (if any), then play.
   public handleSegmentEnding()
   {
    const context = this.autoPlayContext;
    this.autoPlayContext = null;

    const player = this.player as IPlayer;
    const targetMs = context ? resolveOnContinueMs(context.segment?.onContinue, {
      entry: context.entry,
      entries: this.captions ?? [],
      currentMs: player.getCurrentTime(),
      getMarkerEntry: (name: string) => this.timestampController?.getEntryForMarker(name) ?? null,
    }) : null;

    if (targetMs != null) {
      player.seekTo(targetMs);
    }

    this.resumeVideo();
   }

   public continueLesson()
   {
      if (this.segmentNavigator && !this.segmentNavigator.complete() && this.canContinueLesson ) {
       this.cardChanging = true;

       this.$nextTick(()=>{
          this.cardChanging =false;
          if (this.segmentNavigator)
          {
            this.cardData= this.lessonController.buildCardWithNavigator(this.segmentNavigator, true);
            this.initEvents(this.cardData);
          }
       })
        
      }
      else if (this.segmentNavigator?.complete() || this.canContinueLesson) {
        if (this.autoPlayContext) {
          this.handleSegmentEnding();
        }
        else {
          this.resumeVideo();
        }
      }
   }

    protected playElement(el: HTMLAudioElement)
   {
     let sfx= this.preferencesController.getNumber("lesson.sfx",1.0);    
     playElement(el, sfx)
   }

  
     

   public resumeVideo()
   {
    //TODO: update player to be just play.  Need to make YT wrapper.
    // After the end screen, closing a card returns to it instead of restarting the video.
    if (!this.completeLessonResponse) {
      this.player.play();
    }
    this.cardData= null;
   }

   public created()
   { 
 
     const initialize = ()=>{
        this.state= CardViewerState.started;
        this.lessonContext = this.lessonController.lessonContext;
        //set up progress in the VM
        Promise.allSettled([
            this.cardFactory.loadLanguagePacks(this.lessonController.lesson.language)
            //,this.loadLanguageFeatures(this.lessonController.lesson.language)
            ])
        .then(()=>{
           //go ahead and play the video
        }).catch(error=>{
          //console.error(error);
          throw error;
        })
     };

     if (this.lessonController.loaded)
     {
      initialize();
     }
     else if (this.lessonController.loadError)
     {
      this.state = CardViewerState.error;
     }
     else { 
       //attach event handlers
       this.lessonController.events.on("lessonReady",()=>{  
        initialize();
       });

       this.lessonController.events.on("loadLessonError",()=>{  
        //what?
        this.state = CardViewerState.error;
       });
 
     }
 
    //TODO: listen in to relevant events     
    // this.lessonController.events.on("encounter",this.onEncounter);
    // this.lessonController.events.on("encounter-update", this.onEncounterUpdate)
    // this.lessonController.events.on("practice",this.onPractice);
    //this.lessonController.events.on("lessonCompleted",this.lessonCompleted); 
 
   }


   private eventsAttached = false;
 
   public mounted()
   {
    safariViewportFix();
    this.onResize();
    window.addEventListener("resize", this.onResize);
     
   
    this.mediaQuery = window.matchMedia('(orientation: portrait)')
    this.isPortrait = this.mediaQuery.matches
    this.mediaQuery.addEventListener('change', this.onOrientationChange)

    this.emurseContext.events.on("favoriteAppended", this.onFavoriteAppended);
    this.emurseContext.events.on("favoriteRemoved", this.onFavoriteRemoved);
  }

  beforeUnmount(): void {
    this.emurseContext.events.off("favoriteAppended", this.onFavoriteAppended);
    this.emurseContext.events.off("favoriteRemoved", this.onFavoriteRemoved);
    this.mediaQuery?.removeEventListener('change', this.onOrientationChange)
    window.removeEventListener("resize", this.onResize);
  }

   public onResize()
   {
    resizeFillRow(this.$refs.captionsList as HTMLElement)

    if (this.$refs.termsList) {
      resizeFillRow(this.$refs.termsList as HTMLElement)
    }
   }

   public toggleTermsPanel()
   {
    this.showTermsPanel = !this.showTermsPanel;
    this.$nextTick(() => this.onResize());
   }

   // Transcript order is the segment's term order. Favorites come from the favorites map when it's loaded; otherwise false.
   protected initTermsPanel()
   {
    const segment = this.lessonController.lesson?.segments?.find((s: any) => isTranscriptTermsSegment(s));
    const terms: any[] = (segment?.terms ?? []).filter((t: any) => t);

    terms.forEach(t => this.emurseContext.setFavoriteStatus(t));
    this.transcriptTerms = terms;

    const courseUid = this.emurseContext.courseUid;

    if (courseUid) {
      this.courseRepository.getCourseProperties(courseUid).then(properties => {
        this.detailRowConfig = properties?.termListDetailRow ?? null;
      }).catch(() => {
        this.detailRowConfig = null;
      });
    }
   }

   // A heart in one tab updates the same term in the other.
   public onFavoriteAppended(term: any)
   {
    this.syncFavorite(term?.id, true);
   }

   public onFavoriteRemoved(term: any)
   {
    this.syncFavorite(term?.id, false);
   }

   protected syncFavorite(id: string, isFavorite: boolean)
   {
    if (!id) return;

    const apply = (t: any) => {
      if (t && t.id == id) t.isFavorite = isFavorite;
    };

    this.transcriptTerms.forEach(apply);
    this.captions?.forEach((c: any) => {
      apply(c.term);
      c.terms?.forEach(apply);
    });
   }

   public addFavorite(term: Term)
   {
      const language=this.getLanguage();
      this.emurseContext.appendFavorite({id: term.id, type: term.type} as Term, language );
   }

   public removeFavorite(term: Term)
   {
      const language=this.getLanguage();
      this.emurseContext.removeFavorite({id: term.id, type: term.type} as Term, language );
   }

   private getLanguage()
   {
      let lang =this.languageFeatures?.language() ?? "";
      if (!lang) lang =this.lessonController.lesson.language;
      return lang;
    }

   
   
}
</script>

<style lang="scss" scoped>
 @import '@/theme/_helpers.scss';

.time-stamp {
  font-family: monospace;
  vertical-align: middle;
  cursor: pointer;
}

.theme-dark {
  hr {
    opacity:25%;
  }

  .table {
    color: #F4F4F4;
  }
 
//  .emurse-link-component a.lesson-item .lesson-title {
//          color:#FF00FF !important;
//  } 
  .card-item {
     :deep(.lesson-item strong)
     {
      color:#F4F4F4 !important;
    }
  }

    :deep(.reading-card) {
      h1, h2, h3, h4, h5, h6,
      .h1, .h2, .h3, .h4, .h5, .h6 {
        color: #B4B4B4 !important;
      }
    }
}
 
.yt-iframe.embed-responsive-item {
  width: 100% !important;
  height: 100% !important;
}

.caption-active {
  font-weight: bold;
  opacity: 1 !important;
}

.caption-new {
  opacity: .15;
}

.text-related {
  font-size: 1rem; 
}

.caption-visited {
  opacity: .45;
}

.captions-list,
.terms-list {
  overflow-y: auto;
  display: flex;
  flex-direction: column;  
}

.captions-container {
  font-size:1.25rem;
  max-height: 100vh;

.captions-spacer {
  flex: 1 1 0;   // grow:1, shrink:1, basis:0 — both spacers split space evenly
  min-height: 0; // lets it actually shrink to 0 rather than defaulting to content size
}
}

.terms-list {
  font-size: 1rem;
}

.transcript-detail-row {
   font-size:.875rem;
   font-weight:normal;
}

.related-terms {
   font-size:.75rem;
   font-weight:normal;
   opacity: .90;
}

.annotation,
.caption-active .annotation {
  font-style: italic; 
  font-weight: normal;
}

  @include media-breakpoint-down(md) {
    .captions-container
    {
       font-size:1rem;
    }
  }

.player-overlay 
{
  position: absolute;
  top: 0px;
  bottom: 0px;
  right: 0px;
  left:0px;
  pointer-events: none;

  .overlay-view {
    position:absolute;
    top: 0px;
    bottom: 0px;
    right: 0px;
    left:0px;
    pointer-events: auto;
  }


  .hud-youtube {
    margin-top: 5rem;
  }

  .hud-item {
    pointer-events: auto;
  }

  .fixed-overlay {
    position:fixed;
    top: 0px;
    bottom: 0px;
    right: 0px;
    left:0px;
    z-index: 3;
  }
}

</style>